import { httpClient } from '../commons/httpClient'

export interface ForgotPasswordValues {
  email: string
}

export const saveForgotPasswordValue = (data: ForgotPasswordValues): Promise<any> => {
  return httpClient.post('/Account/ForgetPassword', data)
}

export const getCodeForResetPassword = (code: string) => {
  let encodedCode = encodeURIComponent(code)
  return httpClient.get(`/Account/ForgetPassword?code=${encodedCode}`)
}

export interface ForResetPasswordValues {
  email: string
  password: string
  code: string
}

export const saveForResetPassword = (data: ForgotPasswordValues): Promise<any> => {
  return httpClient.post('/Account/ResetPassword', data)
}
